import { apiClient, type Paginated } from '@/core/api';

export { resolveContentType, type ContentTypeRef } from '@/features/comments/api';

/** Mirrors collab TagReadSerializer. Org-scoped, colored label. */
export interface Tag {
  id: number;
  name: string;
  color: string;
  created: string;
  modified: string;
}

/** Mirrors collab TaggedItemReadSerializer — the tag↔object link (GFK target). */
export interface TaggedItem {
  id: number;
  tag: number;
  content_type: number;
  object_id: string;
  created: string;
}

const TAGS = '/collab/tags/';
const TAGGED = '/collab/tagged-items/';

export async function listTags(): Promise<Tag[]> {
  // The org tag vocabulary is small; pull a generous page and treat it as the
  // full set for the picker + name/color lookup.
  const { data } = await apiClient.get<Paginated<Tag>>(TAGS, { params: { page_size: 200 } });
  return data.results;
}

export async function createTag(input: { name: string; color?: string }): Promise<Tag> {
  const { data } = await apiClient.post<Tag>(TAGS, input);
  return data;
}

export interface TaggedItemParams {
  content_type?: number;
  object_id?: string;
}

export async function listTaggedItems(params: TaggedItemParams): Promise<TaggedItem[]> {
  const { data } = await apiClient.get<Paginated<TaggedItem>>(TAGGED, {
    params: { ...params, page_size: 200 },
  });
  return data.results;
}

export async function createTaggedItem(input: {
  tag: number;
  content_type: number;
  object_id: string;
}): Promise<TaggedItem> {
  const { data } = await apiClient.post<TaggedItem>(TAGGED, input);
  return data;
}

export async function deleteTaggedItem(id: number): Promise<void> {
  await apiClient.delete(`${TAGGED}${id}/`);
}
